console.log("mapping")

import mapboxgl from "mapbox-gl"
import "mapbox-gl/dist/mapbox-gl.css"
export function initMap() {
  if (!window.location.href.includes("contact") && !window.location.href.includes("/la-bastide")) {
    return
  }

  mapboxgl.accessToken = "pk.eyJ1IjoiZmxvdmVydCIsImEiOiJjbGYzNXduc3YwYnBuM3hxcHFkZ2trZmE4In0.UpOdRLqxMUmbgXBgOpXSBg"

  const map = new mapboxgl.Map({
    container: "mapbox",
    style: "mapbox://styles/flovert/cldycx3gk00bl01mgy39hbnya",
    center: [4.69194, 43.8582],
    zoom: 12.94
  })

  map.addControl(new mapboxgl.NavigationControl())
  map.scrollZoom.disable()
  map.dragPan.enable()

  const marker1 = new mapboxgl.Marker().setLngLat([4.692, 43.86375]).addTo(map)

  marker1.getElement().addEventListener("click", () => {
    new mapboxgl.Popup({ closeOnClick: false })
      .setLngLat([4.692, 43.86575])
      .setHTML(
        `
        <strong>Hôtel la Bastide de Boulbon</strong><br>
        Coordonnées GPS : 43.86372, 4.69187<br>
        Adresse: 1 chemin de la Lône<br>
        13150 Boulbon - France
      `
      )
      .addTo(map)
  })
}
